import { useEffect, useState } from "react";
import { MessageSquareText, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { tx, uiLocale } from "@/i18n";

const fmt = (iso, opts) => (iso ? new Date(iso).toLocaleString(uiLocale(), opts) : "");

export const RecentCommentsCard = ({ houseId }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`/houses/${houseId}/recent-comments`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [houseId]);

  return (
    <div className="bg-card rounded-xl border border-border p-5 shadow-sm" data-testid="recent-comments-card">
      <div className="flex items-center gap-2 mb-3">
        <MessageSquareText className="h-4 w-4 text-secondary" />
        <h2 className="font-display font-semibold text-lg">{tx("Laatste opmerkingen")}</h2>
        {items?.length > 0 && <span className="ml-auto text-xs text-muted-foreground">{items.length}</span>}
      </div>
      {items === null ? (
        <div className="flex justify-center py-4"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div>
      ) : items.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="recent-comments-empty">{tx("Nog geen opmerkingen bij afspraken.")}</p>
      ) : (
        <ul className="max-h-60 overflow-y-auto -mx-1 px-1 space-y-2" data-testid="recent-comments-list">
          {items.map((c) => (
            <li key={c.id} className="rounded-lg bg-muted/40 px-3 py-2" data-testid={`recent-comment-${c.id}`}>
              <p className="text-sm leading-snug whitespace-pre-line break-words line-clamp-3">{c.text}</p>
              <p className="text-[11px] text-muted-foreground mt-1 truncate">
                {c.author_name} · {fmt(c.created_at, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}
                {c.booking_title ? ` · ${c.booking_title}` : ""}
                {c.booking_start ? ` (${fmt(c.booking_start, { day: "numeric", month: "short" })})` : ""}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
